import React, { FC, useContext } from 'react';

import { Toggle } from '@smartshell/ui-kit';

import { SettingsLock } from 'components';
import { useIsFeatureAvailable } from 'features';
import { LocalizationContext } from 'localization';
import { ESettingsAliases, SettingsContext } from 'settings';

export const ChromeDownloadRestrict: FC = () => {
  const { t } = useContext(LocalizationContext);
  const isAvailable = useIsFeatureAvailable('restrict_chrome_download');

  const {
    state: { settings },
    actions: { setSetting },
  } = useContext(SettingsContext);
  return (
    <>
      <Toggle
        label={t('settings.shell.security.chrome.title')}
        description={t('settings.shell.security.chrome.description')}
        value={settings.isChromeDownloadRestrict}
        onChange={(value: string) => {
          setSetting({
            alias: ESettingsAliases.SHELL_RESTRICT_CHROME_DOWNLOAD,
            value: value ? '1' : '0',
          });
        }}
        variant="secondary"
        emptyBg
        disabled={!isAvailable}
        rightContent={!isAvailable ? <SettingsLock /> : undefined}
      />
    </>
  );
};
